import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Divider } from 'react-native-elements';

import { CustomIcon } from '@views/shared/CustomIcon';
import { colors, spacings } from '@views/shared/styles';

interface Props {
  onMinus: () => void;
  onPlus: () => void;
}

const { medium } = spacings;
const { blackAlpha, aquaMarineLight } = colors;

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: medium,
    right: medium,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    zIndex: 1,
    backgroundColor: aquaMarineLight,
    borderRadius: 10,
    paddingHorizontal: medium,
  },
  button: {
    fontSize: 25,
    marginVertical: medium,
  },
});

export default function Zoommer({ onMinus, onPlus }: Props) {
  return (
    <View style={styles.container}>
      <CustomIcon style={styles.button} name="zoom-in" onPress={onPlus} />
      <Divider style={{ backgroundColor: blackAlpha, width: '100%' }} />
      <CustomIcon style={styles.button} name="zoom-out" onPress={onMinus} />
    </View>
  );
}
